import {
  IPollCreateRequest,
  IPollGetByIdResponse,
  IPollGetRequestParams,
  IPollGetResponsePaginated,
  IPollUpdateRequest,
  TGetPollResultsRequest,
  TGetPollResultsResponsePaginated,
  TOrgDivResponse,
  TPollDivisionsRequest,
  TUpdateStatusRequest,
} from 'shared/types/poll.types';
import { IdResponse, MessageResponse } from 'shared/types/types';
import { edpApiV1 } from './index';

export const pollApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getPoll: build.query<IPollGetResponsePaginated, IPollGetRequestParams>({
      query: params => ({ url: '/v1/moderator/poll/poll', method: 'GET', params }),
      providesTags: ['poll'],
    }),
    getPollById: build.query<[IPollGetByIdResponse], { id: number }>({
      query: params => ({ url: '/v1/moderator/poll/pollById', method: 'GET', params }),
      providesTags: ['poll'],
    }),
    getPollResults: build.query<TGetPollResultsResponsePaginated, TGetPollResultsRequest>({
      query: params => ({ url: '/v1/moderator/poll/results', method: 'GET', params }),
      providesTags: ['pollResults'],
    }),
    createPoll: build.mutation<IdResponse, IPollCreateRequest>({
      query: body => ({
        url: `/v1/moderator/poll/poll`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['poll'],
    }),
    deletePoll: build.mutation<MessageResponse, IdResponse>({
      query: params => ({
        url: `/v1/moderator/poll/poll`,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: ['poll'],
    }),
    updatePoll: build.mutation<IdResponse, IPollUpdateRequest>({
      query: body => ({
        url: `/v1/moderator/poll/poll`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['poll'],
    }),
    updatePollStatus: build.mutation<MessageResponse, TUpdateStatusRequest>({
      query: body => ({
        url: `/v1/moderator/poll/status`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['poll'],
    }),
    getPollDivision: build.query<TOrgDivResponse, TPollDivisionsRequest>({
      query: params => ({ url: '/v1/moderator/poll/division', method: 'GET', params }),
      providesTags: ['pollDivision'],
    }),
    getPollOrganization: build.query<TOrgDivResponse, undefined>({
      query: params => ({ url: '/v1/moderator/poll/organizations', method: 'GET', params }),
      providesTags: ['pollOrganization'],
    }),
    publicateAutoPoll: build.mutation<MessageResponse, TUpdateStatusRequest>({
      query: body => ({
        url: `/v1/moderator/poll/publishing`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['poll'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreatePollMutation,
  useGetPollQuery,
  useLazyGetPollQuery,
  useUpdatePollMutation,
  useGetPollByIdQuery,
  useLazyGetPollByIdQuery,
  useUpdatePollStatusMutation,
  useGetPollDivisionQuery,
  useLazyGetPollDivisionQuery,
  useGetPollOrganizationQuery,
  useLazyGetPollOrganizationQuery,
  useLazyGetPollResultsQuery,
  useDeletePollMutation,
  usePublicateAutoPollMutation,
} = pollApi;
